import React from 'react';

const FieldHockey = ({ className }) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width='14'
            height='14'
            viewBox='0 0 24 24'
            className={className}
        >
            <g clip-path='url(#clip0_14546_80191)'>
                <path d='M19.5574 24C17.6075 24 16.0282 22.4207 16.0282 20.4709C16.0282 18.521 17.6075 16.9417 19.5574 16.9417C21.5072 16.9417 23.0865 18.521 23.0865 20.4709C23.0865 22.4207 21.5072 24 19.5574 24ZM19.4295 8.7585L12.1859 19.7253C11.008 21.512 9.00965 22.5883 6.87011 22.5883C3.3542 22.5883 0.5 19.7341 0.5 16.2182V15.1771C0.5 13.814 1.60727 12.7067 2.9704 12.7067C4.33353 12.7067 5.4408 13.814 5.4408 15.1771V16.2182C5.4408 17.0079 6.08046 17.6475 6.87011 17.6475C7.35095 17.6475 7.80092 17.4049 8.06561 17.0035L15.2386 6.13811L19.4295 8.7585ZM18.556 1.11349C19.3059 -0.0290718 20.8367 -0.342284 21.9793 0.40766C23.1218 1.1576 23.4306 2.69278 22.6807 3.83093L20.5985 6.98952L16.4076 4.36913L18.5604 1.10908L18.556 1.11349Z' />
            </g>
        </svg>
    );
};

export default FieldHockey;
